
import Icon from 'vux/src/components/icon/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import { mapActions } from "vuex";
import loadScript from "@/config/loadScript";
import Model from "@/models/yunMobile";
export default {
components: {
Icon,
PopupPicker
},
data() {
return {
provinces: [
[
"北京（京）",
"天津（津）",
"黑龙江（黑）",
"吉林（吉）",
"辽宁（辽）",
"河北（冀）",
"河南（豫）",
"陕西（陕）",
"内蒙古（蒙）",
"宁夏（宁）",
"甘肃（甘）",
"新疆（新）",
"青海（青）",
"西藏（藏）",
"湖北（鄂）",
"安徽（皖）",
"江苏（苏）",
"上海（沪）",
"浙江（浙）",
"福建（闽）",
"湖南（湘）",
"江西（赣）",
"四川（川）",
"重庆（渝）",
"贵州（贵）",
"云南（滇）",
"山东（鲁）",
"山西（晋）",
"广东（粤）",
"广西（桂）",
"海南（琼）",
"香港（港）",
"澳门（澳）",
"台湾（台）"
]
],
words: [
[
"A",
"B",
"C",
"D",
"E",
"F",
"G",
"H",
"I",
"J",
"K",
"L",
"M",
"N",
"O",
"P",
"Q",
"R",
"S",
"T",
"U",
"V",
"W",
"X",
"Y",
"Z"
]
],
provValue: ["湖南（湘）"],
wordValue: [],
nos: "",
formData: {
parkNo: this.$route.params.parkNo,
passNo: this.$route.params.passid
}
};
},
computed: {
provText() {
if (this.provValue.length != 0) {
let start = this.provValue[0].indexOf("（") + 1,
end = this.provValue[0].indexOf("）");
return this.provValue[0].slice(start, end);
}
return "";
},
wordText() {
if (this.wordValue.length != 0) {
return this.wordValue[0];
}
return "";
},
noText() {
let str = this.provText + this.wordText + this.nos;
return str.toUpperCase().replace(/\s+/g, "");
}
},
methods: {
...mapActions("yunMobile", {
sendPhone: "setCarinBranchAction"
}),
provCheck() {
this.$refs.prov.showValue = true;
},
wordCheck() {
this.$refs.word.showValue = true;
},
send() {
if (!this.wordText || !this.nos) {
this.$layer.msg("请输入车牌号码");
return;
}
this.sendPhone({ ...this.formData, carNo: this.noText }).then(() => {
this.$router.push({ path: `/mobile/yunMobile/confirmPay/2` });
});
},
enterCode(e) {
let num = parseInt(e.target.getAttribute("num"));
if (this.nos["no" + num].length != 0 && this.$refs["noInp" + (num + 1)]) {
this.$refs["noInp" + (num + 1)].focus();
}
},
removeCode(e) {
let num = parseInt(e.target.getAttribute("num"));
if (e.keyCode == 8 && this.$refs["noInp" + (num - 1)]) {
this.nos["no" + num] = "";
this.$refs["noInp" + (num - 1)].focus();
}
},
linkToPhone() {
this.$router.push({
path: `/mobile/yunMobile/branch/enterPhone/${
this.$route.params.parkNo
}/${this.$route.params.passid}?pay=1`
});
}
},
created() {
if (this.formData.passNo != -1) {
this.sendPhone(this.formData).then(() => {
this.$router.push({ path: `/mobile/yunMobile/confirmPay/2` });
});
}
sessionStorage.removeItem("isNoCar");
let carNo = localStorage.getItem("carNo");
if (carNo) {
let prov = carNo.substring(0, 1),
word = carNo.substring(1, 2),
no = carNo.substring(2, carNo.length);
let provValue = this.provinces[0].find(
item => item.indexOf(`（${prov}）`) != -1
);
let wordValue = this.words[0].find(item => item == word);
if (provValue && wordValue) {
this.provValue = [provValue];
this.wordValue = [wordValue];
this.nos = no;
}
}
},
mounted() {
Model.getAdvertising({ parkNo: this.$route.params.parkNo, number: 2 }).then(
res => {
loadScript("http://sdk.anbokeji.net/adv/index.js", () => {
const st = document.querySelector("#anbo-ad-st");
if (st) {
document.body.removeChild(st);
}
const script = document.createElement("script");
script.type = "text/javascript";
script.id = "anbo-ad-st";
script.innerHTML = `__anbo_adv_sdk__.init({appid: "${
res.data.appid
}", adPosId: 4,parkId: "${res.data.parkId}"})`;
document.body.append(script);
document.querySelector(".advwrap").innerHTML =
"<anboadv @show='advShow'></anboadv>";
window.advShow = function(res) {

};
});
}
);
}
};



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/enterCar.vue